<template>
  <div class="flex justify-center mb-5" v-if="isAdmin">
    <router-link :to="url">
      <a
        href="#"
        class="font-semibold text-gray-700 text-sm tracking-wider
                  hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
      >
        Admin Chat (without video)
      </a>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Admin Chat Link",
  components: {},
  props: {
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    url() {
      if (this.id == null) {
        return "/adminChat";
      } else {
        return "/adminChat/" + this.id;
      }
    }
  },
  methods: {}
};
</script>

<style scoped></style>
